module.exports = __webpack_public_path__ + "static/img/6.3de8ab3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/eng/6.png
// module id = S4Oz
// module chunks = 0